var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGysLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 191.13 45.23",
    style: {
      enableBackground: "new 0 0 191.13 45.23"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8A1F75;}\n\t.st1{opacity:0.751;enable-background:new    ;}\n\t.st2{enable-background:new    ;}\n\t.st3{fill:#262626;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group_9469_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9462_2_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_9460_2_",
    transform: "translate(0 21.461)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_1355_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M6.41,3C5,4.95,3.33,6.69,1.45,8.18l0.86,3.72l15.3,9.81l-0.43-5.77c1.28-0.55,2.45-1.32,3.46-2.28 c1.42-1.28,2.73-2.68,3.92-4.18c0.99-1.22,1.96-2.53,2.9-3.92h-0.26c-3.56,0-7.11-0.31-10.61-0.92 c-3.25-0.57-6.43-1.45-9.51-2.62"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1356_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M46.77,7.26c-1.34,1.68-2.89,3.19-4.6,4.49c-1.81,1.39-3.73,2.63-5.75,3.7c-2.03,1.08-4.13,2.01-6.29,2.78 c-2.02,0.72-4.08,1.27-6.19,1.66c-1.79,0.36-3.61,0.5-5.43,0.44l0.1,1.38c1.63,0.2,3.28,0.29,4.93,0.26 c4.57-0.08,9.11-0.79,13.49-2.12c2.52-0.76,4.96-1.77,7.29-3c2.46-1.3,4.75-2.9,6.82-4.77L46.77,7.26z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1357_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M47.38,1.99c-2.71,1.03-5.5,1.83-8.35,2.4c-1.51,2.35-3.29,4.51-5.31,6.43c-2.1,2.01-4.48,3.7-7.07,5.02 c-2.6,1.32-5.39,2.21-8.27,2.64l0.08,1.12c1.85,0,3.7-0.22,5.5-0.64c2.22-0.51,4.39-1.23,6.47-2.16 c2.35-1.03,4.58-2.3,6.68-3.78c2.28-1.59,4.37-3.44,6.23-5.51"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1358_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.28,4.87c-2.05,0.31-4.12,0.51-6.2,0.6c-0.7,1.01-1.43,1.98-2.19,2.92c-1.43,1.76-3,3.39-4.7,4.89 c-1.49,1.31-3.15,2.41-4.94,3.27l0.1,1.14c1.89-0.24,3.72-0.8,5.42-1.64c2.08-1.01,4.02-2.27,5.79-3.76 c2.07-1.72,3.94-3.68,5.56-5.83"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1359_2_"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M27.47,5.55l0.04-0.07L27.47,5.55L27.47,5.55z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Path_1360_2_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M48.37,21.65l-5.1-4.75c-0.13,0.4-0.27,0.79-0.41,1.18c-0.02,0.07-0.05,0.13-0.08,0.2 c-0.12,0.33-0.25,0.66-0.38,0.98l-0.04,0.1c-0.83,2.08-1.84,4.09-3.02,6c-0.1,0.17-0.21,0.33-0.32,0.5 c2.84-0.57,5.64-1.37,8.35-2.4C47.72,22.87,48.05,22.27,48.37,21.65z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1361_2_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M36.64,25.81c0.12-0.17,0.24-0.35,0.35-0.53l0.1-0.16c0.74-1.15,1.45-2.38,2.12-3.67 c0.4-0.78,0.79-1.58,1.16-2.41c0.24-0.54,0.48-1.1,0.7-1.65c0.1-0.24,0.2-0.5,0.29-0.75l0.04-0.11 c0.77-2.07,1.42-4.19,1.93-6.34l-5.4-4.35c0.07,1.84-0.11,3.69-0.56,5.48c-0.51,2.14-1.2,4.23-2.06,6.25 c-0.95,2.18-2.04,4.3-3.27,6.34c-0.62,1.03-1.27,2.03-1.95,3c2.08-0.09,4.15-0.29,6.2-0.6C36.4,26.16,36.52,25.98,36.64,25.81z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_1362_2_",
    className: "st1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.61,26.1c3.5,0.61,7.05,0.92,10.61,0.92h0.26l0.05-0.07l0.19-0.28c0.27-0.41,0.54-0.82,0.8-1.24 c0.27-0.42,0.55-0.88,0.82-1.33l0.13-0.22c0.91-1.53,1.76-3.11,2.53-4.72c1-2.06,1.84-4.2,2.52-6.39 c0.61-1.92,0.97-3.91,1.08-5.93c0.13-1.66-0.15-3.32-0.8-4.84L13.74,2.61c0,0.02-0.03,0.44-0.1,1.28s-0.21,1.96-0.44,3.39 c-0.08,0.45-0.17,0.92-0.27,1.41L12.9,8.86l-0.03,0.16c-0.2,0.95-0.45,1.97-0.74,3.06v0.02c-0.09,0.35-0.19,0.7-0.3,1.05 c-0.03,0.1-0.06,0.21-0.09,0.31v0.02c-0.31,1.02-0.67,2.05-1.08,3.1c-0.14,0.38-0.3,0.76-0.46,1.14 c-0.22,0.53-0.45,1.05-0.71,1.56l-0.06,0.12c-0.09,0.18-0.18,0.36-0.27,0.55s-0.18,0.34-0.27,0.52l-0.09,0.17 c-0.11,0.2-0.22,0.4-0.33,0.6l-0.07,0.12c-0.1,0.18-0.21,0.36-0.31,0.53l-0.13,0.23c-0.07,0.12-0.15,0.24-0.22,0.37 c-0.1,0.16-0.2,0.32-0.3,0.48l-0.05,0.07c-0.09,0.14-0.18,0.28-0.27,0.43C10.18,24.65,13.36,25.52,16.61,26.1z"
  })))), /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M60.78,30.22c-3.89,0-6.93-3.12-6.93-7c0-3.91,3.01-7.04,6.9-7.04c2.2,0,4.07,0.99,5.19,2.58l-1.31,0.97 c-0.81-1.19-2.21-1.93-3.87-1.93c-2.99,0-5.24,2.41-5.24,5.42c0,2.9,2.29,5.38,5.28,5.38c1.42,0,2.75-0.32,3.78-1.06v-3.22h-3.58 v-1.57h5.15v5.55C64.76,29.63,62.82,30.22,60.78,30.22z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M71.31,16.81c0.58,0,1.04,0.47,1.04,1.04s-0.47,1.04-1.04,1.04s-1.04-0.47-1.04-1.04S70.74,16.81,71.31,16.81 z M72.1,20.14v9.81h-1.6v-9.81H72.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M76.77,29.95v-8.26h-1.35v-1.55h1.35V18.8c0-1.82,1.37-2.63,2.81-2.63c1.06,0,2.07,0.4,2.75,1.3l-1.22,0.92 c-0.36-0.43-0.99-0.67-1.57-0.67c-0.47,0-1.19,0.29-1.19,1.08v1.33H81v1.55h-2.65v8.26H76.77z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M87.01,17.89v2.25h2.85v1.55h-2.85v5.65c0,0.92,0.54,1.31,1.04,1.31c0.58,0,0.77-0.27,1.13-0.7l1.3,0.97 c-0.68,0.9-1.33,1.3-2.39,1.3c-1.44,0-2.63-0.88-2.63-2.7v-5.83h-1.19v-1.55h1.19v-2.25H87.01z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M97.31,29.95v-4.48l-4.72-9.02h1.82l3.71,7.22l3.82-7.22h1.8l-4.81,9.02v4.48H97.31z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M109.6,19.88c2.84,0,5.13,2.32,5.13,5.17s-2.29,5.15-5.13,5.15c-2.85,0-5.11-2.3-5.11-5.15 S106.75,19.88,109.6,19.88z M109.6,28.6c1.96,0,3.53-1.58,3.53-3.55s-1.57-3.6-3.53-3.6c-1.96,0-3.51,1.64-3.51,3.6 S107.64,28.6,109.6,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M121.86,30.2c-1.84,0-3.87-0.94-3.87-4.63v-5.44h1.6v4.75c0,2.14,0.38,3.75,2.45,3.75 c1.71,0,2.77-1.48,3.15-2.54v-5.96h1.6v9.81h-1.48l-0.13-1.71C124.45,29.28,123.32,30.2,121.86,30.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M136.22,19.88v1.78c-1.91,0-3.01,1.26-3.38,2.32v5.96h-1.55v-9.81h1.42l0.13,1.71 C133.43,20.8,134.56,19.88,136.22,19.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M140.85,19.56c0,0.9,0.18,1.62,2.77,2.56c2.3,0.83,4.16,1.8,4.16,4.25c0,1.98-1.66,3.85-4.18,3.85 c-2.18,0-3.64-1.1-4.74-2.81l1.24-0.97c0.59,0.9,1.75,2.21,3.53,2.14c1.33-0.05,2.45-1.01,2.45-2.23c0-1.4-1.26-2.03-3.42-2.84 c-2.07-0.77-3.46-1.73-3.46-3.92c0-1.58,1.4-3.4,3.83-3.4c1.44,0,3.01,0.27,4.34,1.93l-1.31,0.97c-0.92-1.01-1.8-1.3-3.02-1.3 C141.62,17.78,140.85,18.68,140.85,19.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M153.27,17.89v2.25h2.84v1.55h-2.84v5.65c0,0.92,0.54,1.31,1.04,1.31c0.58,0,0.77-0.27,1.13-0.7l1.3,0.97 c-0.68,0.9-1.33,1.3-2.39,1.3c-1.44,0-2.63-0.88-2.63-2.7v-5.83h-1.19v-1.55h1.19v-2.25H153.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M164.16,19.88c2.84,0,5.13,2.32,5.13,5.17s-2.29,5.15-5.13,5.15c-2.85,0-5.11-2.3-5.11-5.15 S161.31,19.88,164.16,19.88z M164.16,28.6c1.96,0,3.53-1.58,3.53-3.55s-1.57-3.6-3.53-3.6c-1.96,0-3.51,1.64-3.51,3.6 S162.19,28.6,164.16,28.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M177.93,19.88v1.78c-1.91,0-3.01,1.26-3.38,2.32v5.96h-1.55v-9.81h1.42l0.13,1.71 C175.14,20.8,176.27,19.88,177.93,19.88z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M180.59,20.14h1.73l2.86,6.54l2.7-6.54h1.69l-5.82,14.31h-1.58l2.16-5.91L180.59,20.14z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGysLogo);
export default __webpack_public_path__ + "static/media/GYS-logo.922de3f834a415ff6262d71f2fb4d62a.svg";
export { ForwardRef as ReactComponent };